export enum HandballResultId {
  FirstHalf = 4,
  SecondHalf = 5,
  FirstExtratimeFirstHalf = 589,
  FirstExtratimeSecondHalf = 590,
  SecondExtratimeFirstHalf = 591,
  SecondExtratimeSecondHalf = 592,
}
